module.exports = __webpack_public_path__ + "static/img/publicity-icon2.90f8fcc.png";


//////////////////
// WEBPACK FOOTER
// ./static/publicity-icon2.png
// module id = Ck/W
// module chunks = 1